import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IChannelNotificationFirmData } from 'types/DashboardType'
import { saveAsExcelFile } from 'utils/Miscellaneous'
import ExportBtn from './ExportBtn'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function ChannelDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [
        [
          t('most-used-words.firm'),
          t('most-used-words.location'),
          'Android',
          'IOS',
          'Huawei',
          'Web',
          t('dashboard.num-of-all-notification'),
        ],
      ]

      const arr = excelData?.map((res: any) => {
        const {
          firmName,
          locationName,
          androidReservationCount,
          iosReservationCount,
          huaweiReservationCount,
          webReservationCount,
          totalReservationCount,
        } = res || {}

        return {
          FirmName: firmName || '---',
          LocationName: locationName || '',
          AndroidReservationCount: androidReservationCount,
          IOSReservationCount: iosReservationCount,
          HuaweiReservationCount: huaweiReservationCount,
          WebReservationCount: webReservationCount,
          TotalReservationCount: totalReservationCount,
        }
      })

      const totalRow = arr.reduce(
        (acc: IChannelNotificationFirmData, curr: IChannelNotificationFirmData) => {
          acc.androidReservationCount += curr.androidReservationCount || 0
          acc.iosReservationCount += curr.iosReservationCount || 0
          acc.huaweiReservationCount += curr.huaweiReservationCount || 0
          acc.webReservationCount += curr.webReservationCount || 0
          acc.totalReservationCount += curr.totalReservationCount || 0
          return acc
        },
        {
          firmName: '',
          locationName: t('most-used-words.total'),
          androidReservationCount: 0,
          iosReservationCount: 0,
          huaweiReservationCount: 0,
          webReservationCount: 0,
          totalReservationCount: 0,
        }
      )

      let heading2 = {
        firmName: '',
        androidReservationCount: 'Android',
        iosReservationCount: 'IOS',
        huaweiReservationCount: 'Huawei',
        webReservationCount: 'Web',
        totalReservationCount: t('most-used-words.total'),
      }

      arr.push(...[{}, heading2, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.channel-based-dist'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? <ExportBtn handleExport={handleExport} /> : null}
      {children}
    </>
  )
}
